import { render, staticRenderFns } from "./CostWarning.vue?vue&type=template&id=4a73a056"
import script from "./CostWarning.vue?vue&type=script&lang=js"
export * from "./CostWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports